__turbopack_context__.v({
  "dot": "D5A8rq_dot",
  "indicator": "D5A8rq_indicator",
  "radio": "D5A8rq_radio",
});
